import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { UseraccessserviceService } from '../useraccessservice.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import {catchError} from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService  implements HttpInterceptor{

  constructor( private useraccessservice : UseraccessserviceService, private toastr : ToastrService) { }

    intercept(request : HttpRequest<any>,next:HttpHandler) : Observable<HttpEvent<any>>{   
      const currentUserToken = this.useraccessservice.getCurrentUserToken();
      const isLoggedIn = currentUserToken != null;
    
      if(isLoggedIn && request.url.startsWith(environment.ImpataAppAPIRoot)){  
        request = request.clone({
            setHeaders : {
                Authorization : `Bearer ${currentUserToken}`             
            }            
          });      
      }    
      return next.handle(request);
     
    }

    // handleError(error:HttpErrorResponse){
    //   this.toastr.error("Boom", "Connection Error", { timeOut : 5000 });      
    //   if(error.status === 0){
    //     this.toastr.error("Unable to connect to server", "Connection Error", { timeOut : 5000 });      
    //   }
    //   else if(error.status === 400){        
    //     this.toastr.error(error.error.message, "Error", { timeOut : 5000 });
    //   }
    //   else{
    //     this.toastr.error(error.statusText, "Error", { timeOut : 5000 });
    //   }
    //   return throwError(error);
    // }

}
